// XLSkeleton - Sprint 44 XL.
// Placeholder con shimmer para loading states. Variantes: rect | line | circle.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';

const CSS_ID = 'xl-skeleton-css';
const CSS = `
.xl-skeleton {
  display: inline-block;
  background: var(--xl-color-surface-alt);
  border-radius: var(--xl-radius-sm);
  vertical-align: middle;
}
.xl-skeleton--line   { height: 12px; width: 100%; border-radius: 4px }
.xl-skeleton--rect   { height: 80px; width: 100%; border-radius: var(--xl-radius-md) }
.xl-skeleton--circle { border-radius: var(--xl-radius-full) }
`;

export default function XLSkeleton({
  variant = 'line',
  width,
  height,
  className = '',
  ariaLabel = 'Cargando',
}) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const sizeStyle = {};
  if (width)  sizeStyle.width  = typeof width  === 'number' ? width  + 'px' : width;
  if (height) sizeStyle.height = typeof height === 'number' ? height + 'px' : height;

  return (
    <span
      role="status"
      aria-label={ariaLabel}
      aria-busy="true"
      className={
        'xl-skeleton xl-skeleton--' + variant + ' xl-shimmer ' + className
      }
      style={sizeStyle}
    />
  );
}
